import { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import earn from './img/transfer_money.svg';

export default function P2PII() {
  const [refII, inViewII] = useInView({
    rootMargin: '-100px 100px'
  });
  const control = useAnimation();

  const leftVariant = {
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
      transition: { duration: 0.5 }
    },
    hidden: {
      opacity: 0,
      x: -20,
      y: -20
    }
  }

  const rightVariant = {
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
      transition: { duration: 0.5 }
    },
    hidden: {
      opacity: 0,
      x: 20,
      y: -20
    }
  }

  useEffect(() => {
    if (inViewII) { control.start('visible') }
    if (!inViewII) { control.start('hidden') } 
  }, [control, { refII, inViewII }]);

  return (
    <>
      <div className="chooseUs-item">
        <h3 className="mView-header">Instant Exchange</h3>
        <motion.img
          src={earn} alt="vault" className="chooseUs-img"
          ref={refII}
          variants={leftVariant}
          initial="hidden"
          animate={control}
        />
        <motion.div
          className="chooseUs-item-note"
          ref={refII}
          variants={rightVariant}
          initial="hidden"
          animate={control}
        >
          <h3 className="mView-header-II">Instant Exchange</h3>
          <p>Sell crypto and receive the naira equivalent in your bank account within minutes!</p>
        </motion.div>
      </div>
    </>
  )
}
